// extracted by mini-css-extract-plugin
export default {"payment-methods-layout":"payment-methods-layout_payment-methods-layout__s7YlA","payment-methods-layout__group-pl":"payment-methods-layout_payment-methods-layout__group-pl__LDhJS"};